import {
  automaticField,
  characterField,
  inkField,
} from "../content/lianxi/exercise-fields.js";
import { shapeText } from "../handwriting/handwriting-line.js";
import { characterShape } from "../handwriting/stroke-shape.js";
import type { RecordAnswer } from "./lianxi-post.js";
import type { CharacterMarker, CheckedCharacter } from "./xiezi-check.js";

/**
 * The free stage marked by the `/user/lianxi/` handler.
 *
 * The ink is posted in the format a 复习 handwriting card posts, the handler
 * marks it with the grader the card is marked by and keeps the outcome in the
 * same write, and the mark comes back in the shape the drill reads one. Ink
 * the drill sent on its own says so, and the handler keeps only a pass of it.
 * The page fetches no handwriting index for this. `lianxi-recorder.ts`
 * supplies the post.
 */

/** What a reader is told when their writing could not be sent to be marked. */
export const unsentLine =
  "Your writing could not be sent to be marked. Check your connection and press Check again.";

/**
 * A marker that posts the ink and takes the handler's mark.
 * @param post - One press, naming the Exercise, answered or not.
 * @returns The marker.
 */
export function remoteMarker(
  post: (
    fields: Readonly<Record<string, string>>,
  ) => Promise<RecordAnswer | undefined>,
): CharacterMarker {
  return async (character, ink, asked): Promise<CheckedCharacter> => {
    const answer = await post({
      [characterField]: character,
      [inkField]: shapeText(characterShape(ink)),
      ...(asked === "automatic" ? { [automaticField]: "" } : {}),
    });

    return answer?.marked === undefined
      ? {
          reading: { verdict: "unrecognised", drawn: ink.length, expected: 0 },
          passed: false,
          marked: false,
          line: unsentLine,
        }
      : (answer.marked as CheckedCharacter);
  };
}
